import styled from '@emotion/styled';

import { TablePanel } from '@/components/common/Panel/style';
import { pageSectionLayout } from '@/styles/pageLayout';

export { TablePanel };

export const Container = styled.main`
	${pageSectionLayout}
	display: flex;
	flex-direction: column;
	gap: 8rem;
`;
export const ContentBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2.4rem;
`;
export const ContentTitle = styled.p`
	color: #212529;
	font-size: ${(props) => props.theme.fontSize.sizeXl || '2.4rem'};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi || '600'};
	line-height: ${(props) => props.theme.ui.lineHeight.heading};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
`;
export const ContentDescription = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.8rem;
	color: #212529;
	font-size: 1.6rem;
	line-height: ${(props) => props.theme.ui.lineHeight.heading};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	li {
		position: relative;
		padding-left: 1.5rem;
		&::after {
			content: '';
			position: absolute;
			top: calc(0.8em - 7px);
			left: 0;
			background-color: currentColor;
			width: 4px;
			height: 4px;
			border-radius: 50%;
		}
	}
`;
export { PageActionRow as BasicInfoButtonBox } from '@/components/common/form/formPageStyles';
export const BasicInfo = styled.ul`
	display: flex;
	flex-direction: column;
	gap: 0.8rem;
	font-size: 1.6rem;
	font-weight: 400;
	line-height: ${(props) => props.theme.lineHeight.tight};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	color: #212529;
	li {
		position: relative;
		padding-left: 1.5rem;
		&::after {
			content: '';
			position: absolute;
			top: calc(0.8em - 7px);
			left: 0;
			background-color: currentColor;
			width: 4px;
			height: 4px;
			border-radius: 50%;
		}
	}
`;
export const Table = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr 2fr;
	grid-auto-rows: minmax(40px, auto);
	white-space: nowrap;
	overflow: auto;
	.item2 {
		grid-column-start: 1;
		grid-column-end: 3;
	}
	.item3 {
		grid-row-start: 2;
		grid-row-end: 4;
	}
`;
export const TableHeadCell = styled.div`
	display: flex;
	align-items: center;
	background-color: ${(props) => props.theme.colors.primary400};
	color: white;
	padding: 10px 15px;
	text-align: left;
	border-right: 2px solid white;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightMedium};
	line-height: ${(props) => props.theme.lineHeight.normal};
	&.center {
		justify-content: center;
	}
`;
export const TableCell = styled.div`
	display: flex;
	align-items: center;
	background-color: #f1f3f5;
	padding: 10px 15px;
	border-right: 2px solid white;
	border-bottom: 2px solid white;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: ${(props) => props.theme.ui.lineHeight.body};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	color: #212529;
	&.point {
		color: ${(props) => props.theme.colors.primary400};
		font-weight: ${(props) => props.theme.fontWeight.weightBold};
	}
	&.center {
		justify-content: center;
	}
	&.min-height {
		min-height: 5.2rem;
	}
`;
export const PositionCell = styled(TableCell)`
	color: ${(props) => props.theme.colors.primary400};
	font-weight: ${(props) => props.theme.fontWeight.weightBold};
`;
export const PaymentBox = styled.div`
	display: grid;
	grid-template-columns: minmax(auto, 26.9rem) auto;
	grid-auto-rows: minmax(52px, auto);
`;
export const PaymentContentName = styled.div`
	display: flex;
	justify-content: flex-start;
	align-items: center;
	background-color: ${(props) => props.theme.colors.primary400};
	color: white;
	padding: 0.8rem 1.2rem;
	min-height: 5.2rem;
	border: 1px solid #fff;
	font-size: 1.6rem;
	font-weight: 500;
	line-height: ${(props) => props.theme.lineHeight.normal};
`;
export const PaymentContent = styled(PaymentContentName)`
	background-color: #f1f3f5;
	color: #212529;

	&.danger {
		color: ${(props) => props.theme.colors.red600};
	}
`;
